import { Component, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-message-box-invite',
  templateUrl: './message-box-invite.component.html',
  styleUrls: ['./message-box-invite.component.css']
})
export class MessageBoxInviteDialog {

  message: any;
  invitations: any;
  errors: any;

  constructor(public dialogRef: MdDialogRef<MessageBoxInviteDialog>,
              @Inject(MD_DIALOG_DATA) public data: any) {
                this.invitations = data.data.invitations;
                this.errors = data.data.errors;
              }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/message-box-invite/message-box-invite.component.ts